import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { fetchApi } from '../../services/api';

export default function classroomBreadcrumb<T extends RouteComponentProps>(
    WrappedComponent: React.ComponentType<T>,
    options: { page?: string } = {}
) {

    type State = {
        roomName: string;
    }

    type Props = RouteComponentProps<{ classroomId: string }>;

    return class extends React.Component<Props, State> {

        constructor(props: Props) {
            super(props);

            this.state = {
                roomName: ''
            }

            this.fetchClassroomName = this.fetchClassroomName.bind(this);
        }

        componentDidMount() {
            this.fetchClassroomName(parseInt(this.props.match.params.classroomId));
        }

        componentWillReceiveProps(nextProps: Props) {
            const currentPage = this.props.location.pathname;
            const nextPage = nextProps.location.pathname;

            if (currentPage !== nextPage) {
                this.fetchClassroomName(parseInt(nextProps.match.params.classroomId));
            }
        }

        render() {
            return <React.Fragment>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to='/classrooms'>Classrooms</Link>
                        </li>
                        {!options.page && <li className="breadcrumb-item active" aria-current="page">{this.state.roomName}</li>}
                        {options.page && <React.Fragment>
                            <li className="breadcrumb-item">
                                <Link to={`/classroom/${this.props.match.params.classroomId}`}>{this.state.roomName || 'Classroom'}</Link>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                                {options.page}
                            </li>
                        </React.Fragment>}
                    </ol>
                </nav>
                <WrappedComponent {...(this.props as T)} />
            </React.Fragment>
                ;
        }

        private fetchClassroomName(classroomId: number) {
            if (classroomId == 0) {
                this.setState({ roomName: "New Classroom" })
            } else {
                fetchApi(`/api/Breadcrumb/Classroom/${classroomId}`)
                    .then((roomName) => this.setState({ roomName }))
            }
        };
    };
}
